module.exports = __webpack_public_path__ + "static/media/19ESCAP12.50ee9aa3.jpg";